// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type {
    GetTopicSettingsQuery,
    BaseResponseListTopicSettingFoundResponse,
    PostTopicSettingsBody,
    BaseResponseTopicSettingFoundResponse,
} from '../types';

/**
 * 话题配置列表
 *
 * @export
 * @tags 话题配置
 * @link [GET] /topicSettings
 */
export function getTopicSettings(
    options: ApiOptions<never, GetTopicSettingsQuery> & { params: GetTopicSettingsQuery }
): Promise<BaseResponseListTopicSettingFoundResponse> {
    return request<never, never, GetTopicSettingsQuery>('/topicSettings', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getTopicSettings',
    });
}

/**
 * 话题配置-保存
 *
 * @export
 * @tags 话题配置
 * @link [POST] /topicSettings
 */
export function postTopicSettings(
    data: PostTopicSettingsBody
): Promise<BaseResponseTopicSettingFoundResponse>;
export function postTopicSettings(
    data: PostTopicSettingsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseTopicSettingFoundResponse>;
export function postTopicSettings(
    data: PostTopicSettingsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseTopicSettingFoundResponse> {
    return request<PostTopicSettingsBody, never, never>('/topicSettings', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postTopicSettings',
    });
}

export const meta = [
    { tags: ['话题配置'], path: '/topicSettings', method: 'get' },
    { tags: ['话题配置'], path: '/topicSettings', method: 'post' },
];
